import { useState } from "react";
import Header from "../../components/Header";
import Gg88GameTypeModal from "../../components/Gg88GameTypeModal";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import "./HomePage.css";

const HomePage = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);

  return (
    <div className="page-with-header home-page">
      <Header setIsShowLogout={() => setIsShowLogout(true)} />

      <Gg88GameTypeModal isInline={false} />

      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => setIsShowLogout(false)}
      />
    </div>
  );
};

export default HomePage;
